(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luverre-five-worlds"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luverre-worlds')) {
    customElements.define('luverre-worlds', class extends HTMLElement {
      connectedCallback() {
        this.worlds = Array.from(this.querySelectorAll('[data-world]'));
        this.links = Array.from(this.querySelectorAll('[data-world-link]'));
        this.jumpLinks = Array.from(this.querySelectorAll('[data-world-jump]'));
        this.videoToggles = Array.from(this.querySelectorAll('[data-video-toggle]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.frameRequested = false;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.handleVideoToggle = this.handleVideoToggle.bind(this);
        this.componentObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.classList.toggle('is-in-view', entry.isIntersecting));
        }, { threshold: 0.02 });
        this.worldObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector('video');
            if (entry.isIntersecting) {
              this.setActiveWorld(entry.target.dataset.world);
              if (video && !this.reduceMotion && video.dataset.userPaused !== 'true') this.playVideo(video);
            } else if (video) {
              this.pauseVideo(video);
            }
          });
        }, { rootMargin: '-43% 0px -43% 0px', threshold: 0 });
        this.componentObserver.observe(this.querySelector('.lv-worlds__journey') || this);
        this.worlds.forEach((world) => this.worldObserver.observe(world));
        this.jumpLinks.forEach((link) => link.addEventListener('click', this.handleLinkClick));
        this.videoToggles.forEach((button) => button.addEventListener('click', this.handleVideoToggle));
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        if (!this.reduceMotion) {
          window.addEventListener('scroll', this.handleScroll, { passive: true });
          window.addEventListener('resize', this.handleScroll, { passive: true });
          this.updateProgress();
        }
      }

      disconnectedCallback() {
        this.componentObserver?.disconnect();
        this.worldObserver?.disconnect();
        this.jumpLinks?.forEach((link) => link.removeEventListener('click', this.handleLinkClick));
        this.videoToggles?.forEach((button) => button.removeEventListener('click', this.handleVideoToggle));
        this.worlds?.forEach((world) => world.querySelector('video')?.pause());
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
      }

      handleScroll() {
        if (this.frameRequested) return;
        this.frameRequested = true;
        requestAnimationFrame(() => {
          this.updateProgress();
          this.frameRequested = false;
        });
      }

      updateProgress() {
        const viewportHeight = window.innerHeight || 1;
        this.worlds.forEach((world) => {
          const rect = world.getBoundingClientRect();
          const stickyTravel = Math.max(1, rect.height - viewportHeight);
          const progress = Math.min(1, Math.max(0, -rect.top / stickyTravel));
          world.style.setProperty('--lv-progress', progress.toFixed(3));
        });
      }

      setActiveWorld(id) {
        let activeLink;
        this.links.forEach((link) => {
          if (link.dataset.worldLink === id) {
            link.setAttribute('aria-current', 'true');
            activeLink = link;
          } else link.removeAttribute('aria-current');
        });

        const scroller = this.querySelector('.lv-worlds__nav');
        if (activeLink && scroller && window.matchMedia('(max-width: 749px)').matches && scroller.scrollWidth > scroller.clientWidth) {
          const left = activeLink.offsetLeft - ((scroller.clientWidth - activeLink.offsetWidth) / 2);
          scroller.scrollTo({ left: Math.max(0, left), behavior: this.reduceMotion ? 'auto' : 'smooth' });
        }
      }

      handleLinkClick(event) {
        const id = event.currentTarget.dataset.worldJump;
        const target = this.querySelector(`[data-world="${CSS.escape(id)}"]`);
        if (!target) return;
        event.preventDefault();
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'start' });
        if (window.location.hash !== `#${id}`) history.pushState(null, '', `#${id}`);
      }

      playVideo(video) {
        video.play()
          .then(() => this.updateVideoToggle(video))
          .catch(() => this.updateVideoToggle(video));
      }

      pauseVideo(video) {
        video.pause();
        this.updateVideoToggle(video);
      }

      updateVideoToggle(video) {
        const button = video.closest('.lv-world__stage')?.querySelector('[data-video-toggle]');
        if (!button) return;
        const label = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
        button.setAttribute('aria-label', label);
        const labelNode = button.querySelector('[data-video-toggle-label]');
        if (labelNode) labelNode.textContent = label;
      }

      handleVideoToggle(event) {
        const video = event.currentTarget.closest('.lv-world__stage')?.querySelector('video');
        if (!video) return;
        if (video.paused) {
          video.dataset.userPaused = 'false';
          this.playVideo(video);
        } else {
          video.dataset.userPaused = 'true';
          this.pauseVideo(video);
        }
      }

      handleBlockSelect(event) {
        const target = this.querySelector(`[data-world-block-id="${CSS.escape(event.detail.blockId)}"]`);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
